import React, { useState, useEffect, useCallback, useMemo, useContext } from 'react';
import { Collapse, Tooltip } from 'antd';
const { Panel } = Collapse;
import Header from './Header';
import AvatarTag from '@web-common/components/UI/Avatar/avatarTag';
import { MAIL_MENU_ITEM } from '../../common/constant';
import ContentTips from './ContentTips';
import useState2RM from '../../hooks/useState2ReduxMock';
import { apiHolder as api, apis, apiHolder, getIn18Text, } from 'api';
import { formatDigitalTime } from '../../util';
import Content from './content/Content';
import IconCard from '@web-common/components/UI/IconCard';
import ReadListIcons from '@web-common/components/UI/Icons/svgs/ReadListSvgs';
import lodashGet from 'lodash/get';
import ReplyWrap from './ReplyWrap';
import useStateRef from '@web-mail/hooks/useStateRef';
import useGetReadStatus from '@web-mail/components/ReadMail/hooks/useGetReadStatus';
import useCreateCallbackForEvent from '@web-mail/hooks/useCreateCallbackForEvent';
import HorizontalScrollBar from './component/VScrollBar/scrollBar';
import { VScrollContent } from '@web-mail/components/ReadMail/useFixedScrollBar';
import { useAppDispatch } from '@web-common/state/createStore';
import { Thunks } from '@web-common/state/reducer/mailReducer';
const systemApi = api.api.getSystemApi();
const mailManagerApi = api.api.requireLogicalApi(apis.mailConfApiImpl);
const htmlApi = apiHolder.api.requireLogicalApi(apis.htmlApi);
const eventApi = api.api.getEventApi();
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const accountApi = api.api.requireLogicalApi(apis.accountApiImpl);
const storeApi = api.api.getDataStoreApi();
const productAuthApi = api.api.requireLogicalApi(apis.productAuthApiImpl);
const MergePanelMail = props => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1;
    const { activeKey, handleSignlDelete, readOnly, content, featureConfig, senderContactMap, showAttachCount, handleRemark, ckey, handleTranslateLang, translateInfoMidMap, unlockMail, forceUpdate, replayFixed, freezeMouse, contentRef, } = props;
    const { handleHorizontalScroll, setContentWidth } = useContext(VScrollContent);
    const dispatch = useAppDispatch();
    const [emotionInfo, setEmotionInfo] = useState();
    const [showMailHead, setShowMailHead] = useState(false);
    const [showAvator] = useState2RM('configMailListShowAvator');
    const shouldAutoReadMail = mailManagerApi.getShouldAutoReadMailSync();
    const account = useMemo(() => {
        var _a;
        return (content === null || content === void 0 ? void 0 : content._account) || ((_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id);
    }, [content]);
    const [scrollLeft, setScrollLeft] = useState(0);
    const MailContentRef = useStateRef(content);
    const [_freezeMouse, setFreezeMouse] = useState(false);
    const isActive = useMemo(() => {
        return activeKey.indexOf(`${content.entry.id}`) > -1;
    }, [activeKey, content]);
    const handleEmoticon = (data, mid) => {
        setEmotionInfo(data);
    };
    const handleMailMarkRead = (mid, _account) => {
        if (mid) {
            eventApi.sendSysEvent({
                eventName: 'mailStatesChanged',
                eventData: {
                    mark: true,
                    id: [mid],
                    type: 'read',
                },
                _account: _account || '',
                eventStrData: 'read',
            });
        }
    };
    const getEmotionInfoByKey = async () => {
        if (!emotionInfo && content) {
            const emotionInfo = await mailApi.getThumbUpInfo(content === null || content === void 0 ? void 0 : content.id, content.entry.tid || '');
            setEmotionInfo(emotionInfo);
        }
    };
    const getMergeMailLang = () => {
        var _a, _b, _c;
        const mid = (_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.id;
        const mailContent = (_c = (_b = content === null || content === void 0 ? void 0 : content.entry) === null || _b === void 0 ? void 0 : _b.content) === null || _c === void 0 ? void 0 : _c.content;
        if (mid && mailContent) {
            dispatch(Thunks.doGetCurrentMailLang({ mid }));
        }
    };
    useEffect(() => {
        if (isActive) {
            getEmotionInfoByKey();
            getMergeMailLang();
        }
    }, [isActive]);
    const { setOpenRecordData, readStatus, rclStatus, readOnlyStatus, debounceGetStatusOrDetail, getStatusOrDetail } = useGetReadStatus(content);
    const refreshData = useCreateCallbackForEvent(() => {
        const id = content === null || content === void 0 ? void 0 : content.id;
        if (!id)
            return;
        getStatusOrDetail(content);
    });
    const [iframeContentWidth, setIframeContentWidth] = useState(0);
    const [iframeWidth, setIframeWidth] = useState(0);
    const handleIframeSizeChange = useCreateCallbackForEvent((params) => {
        const { contentScrollWidth, iframeClientWidth } = params;
        setIframeContentWidth(contentScrollWidth);
        setIframeWidth(iframeClientWidth);
        setContentWidth(content.entry.id, contentScrollWidth, iframeClientWidth);
    });
    const handleIframeScroll = useCallback((position) => {
        handleHorizontalScroll && handleHorizontalScroll(content === null || content === void 0 ? void 0 : content.id, position);
        setScrollLeft(position);
    }, []);
    const handleVScrollOnScroll = useCreateCallbackForEvent((position) => {
        var _a, _b;
        try {
            const irameRef = contentRef.current[ckey].getIframeRef();
            if (irameRef && ((_b = (_a = irameRef.current) === null || _a === void 0 ? void 0 : _a.contentDocument) === null || _b === void 0 ? void 0 : _b.documentElement)) {
                irameRef.current.contentDocument.documentElement.scrollLeft = position;
            }
        }
        catch (e) {
            console.error('scrollLeft error', e);
        }
    });
    useEffect(() => {
        if (isActive) {
            setTimeout(() => {
                setOpenRecordData({ count: 0, records: [] });
                debounceGetStatusOrDetail(MailContentRef.current);
            }, 1000);
        }
    }, [isActive]);
    const otherProps = useMemo(() => {
        return Object.assign(Object.assign({}, props), { handleSignlDelete: undefined, readOnly: undefined, content: undefined, featureConfig: undefined, senderContactMap: undefined, showAttachCount: undefined, handleRemark: undefined, ckey: undefined, listData: undefined, refreshData: undefined, handleTranslateLang: undefined, translateInfoMidMap: undefined, unlockMail: undefined, forceUpdate: undefined, replayFixed: undefined });
    }, [props]);
    return (React.createElement(Panel, Object.assign({}, otherProps, { showArrow: false, header: isActive ? (React.createElement(Header, { isMerge: true, content: content, handleDelete: handleSignlDelete, readOnly: readOnly, showMailDiscuss: featureConfig === null || featureConfig === void 0 ? void 0 : featureConfig.mailDiscuss, mailTagCloseAble: featureConfig === null || featureConfig === void 0 ? void 0 : featureConfig.mailTagIsCloseAble, featureConfig: featureConfig, forceUpdate: forceUpdate, menu: [
                {
                    key: MAIL_MENU_ITEM.MAIL_WITHDRAW_RES,
                    show: false,
                },
                {
                    key: MAIL_MENU_ITEM.MAIL_WITHDRAW,
                    show: false,
                },
                {
                    key: MAIL_MENU_ITEM.EMAIL_HEADER,
                    name: mail => {
                        return showMailHead ? getIn18Text('CHAKANYOUJIAN') : getIn18Text('CHAKANXINTOU');
                    },
                    onClick: mails => {
                        setShowMailHead(!showMailHead);
                    },
                },
            ] })) : (React.createElement("div", { className: "u-item-block" },
            showAvator ? (React.createElement(AvatarTag, { size: 32, contactId: (_c = (_b = (_a = content === null || content === void 0 ? void 0 : content.sender) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.contact) === null || _c === void 0 ? void 0 : _c.id, user: {
                    color: (_f = (_e = (_d = content === null || content === void 0 ? void 0 : content.sender) === null || _d === void 0 ? void 0 : _d.contact) === null || _e === void 0 ? void 0 : _e.contact) === null || _f === void 0 ? void 0 : _f.color,
                    name: (_j = (_h = (_g = content === null || content === void 0 ? void 0 : content.sender) === null || _g === void 0 ? void 0 : _g.contact) === null || _h === void 0 ? void 0 : _h.contact) === null || _j === void 0 ? void 0 : _j.contactName,
                    avatar: (_m = (_l = (_k = content === null || content === void 0 ? void 0 : content.sender) === null || _k === void 0 ? void 0 : _k.contact) === null || _l === void 0 ? void 0 : _l.contact) === null || _m === void 0 ? void 0 : _m.avatar,
                } })) : (React.createElement(React.Fragment, null)),
            React.createElement("div", { className: "u-item-block-content", style: { width: content.taskId ? '50px' : '82px', marginRight: content.taskId ? '4px' : '16px' } },
                shouldAutoReadMail && React.createElement("div", { className: "u-item-block-read", hidden: content.entry.readStatus === 'read' }),
                !shouldAutoReadMail && (React.createElement("div", { className: "u-item-block-markread", onClick: ev => {
                        handleMailMarkRead(content.entry.id, content._account);
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                    }, hidden: content.entry.readStatus === 'read' },
                    React.createElement("div", { className: "u-item-block-markread-dot" }))),
                content.entry.suspiciousSpam && (React.createElement("div", { className: "u-item-block-suspicious" },
                    React.createElement(ReadListIcons.SuspiciousSvg, null))),
                typeof content.entry.priority === 'number' && content.entry.priority < 2 && (React.createElement(Tooltip, { title: getIn18Text('JINJIYOUJIAN'), placement: "top" },
                    React.createElement("div", { className: "u-item-block-alarm" },
                        React.createElement(IconCard, { type: "alarm" })))),
                account === ((_q = (_p = (_o = content === null || content === void 0 ? void 0 : content.sender) === null || _o === void 0 ? void 0 : _o.contact) === null || _p === void 0 ? void 0 : _p.contact) === null || _q === void 0 ? void 0 : _q.accountName)
                    ? getIn18Text('WO')
                    : lodashGet(senderContactMap, (_t = (_s = (_r = content === null || content === void 0 ? void 0 : content.sender) === null || _r === void 0 ? void 0 : _r.contact) === null || _s === void 0 ? void 0 : _s.contact) === null || _t === void 0 ? void 0 : _t.accountName, (_w = (_v = (_u = content === null || content === void 0 ? void 0 : content.sender) === null || _u === void 0 ? void 0 : _u.contact) === null || _v === void 0 ? void 0 : _v.contact) === null || _w === void 0 ? void 0 : _w.contactName)),
            React.createElement("span", { className: "u-item-block-task", hidden: !content.taskId }, getIn18Text('RENWU')),
            React.createElement("div", { className: "u-item-block-text" }, ((_x = content === null || content === void 0 ? void 0 : content.entry) === null || _x === void 0 ? void 0 : _x.brief) ? htmlApi.decodeHtml((_y = content === null || content === void 0 ? void 0 : content.entry) === null || _y === void 0 ? void 0 : _y.brief.trim()) : ''),
            React.createElement("div", { className: "u-item-block-svg" },
                ((_z = content === null || content === void 0 ? void 0 : content.entry) === null || _z === void 0 ? void 0 : _z.eTeamType) === 1 && React.createElement(IconCard, { type: "chat" }),
                showAttachCount > 0 ? React.createElement(ReadListIcons.AttachSvgLarge, null) : '',
                content.entry.mark === 'redFlag' ? (React.createElement("span", { style: { display: 'flex', alignItems: 'center' }, onClick: e => {
                        e.stopPropagation();
                        !readOnly && handleRemark(false, content === null || content === void 0 ? void 0 : content.id, 'redFlag');
                    } },
                    React.createElement(ReadListIcons.RedFlagSvg, null))) : (React.createElement("span", { style: { display: 'flex', alignItems: 'center' }, onClick: e => {
                        e.stopPropagation();
                        !readOnly && handleRemark(true, content === null || content === void 0 ? void 0 : content.id, 'redFlag');
                    }, className: "flag" },
                    React.createElement(ReadListIcons.FlagSvg, null)))),
            React.createElement("div", { className: "u-item-block-time" }, formatDigitalTime(content === null || content === void 0 ? void 0 : content.entry.sendTime)))), key: content.entry.id, id: 'collapse' + content.entry.id, "data-test-id": `mail-thread-panel-${ckey}` }),
        React.createElement("div", { className: "mail-read-content-wrap" },
            readOnly ? (React.createElement(React.Fragment, null)) : (React.createElement(ContentTips, { listData: readStatus, rclData: rclStatus, readOnlyData: readOnlyStatus, refreshData: refreshData, emoticonInfo: emotionInfo, handleEmoticon: handleEmoticon, content: content, featureConfig: featureConfig, handleTranslateLang: (value, from) => {
                    var _a;
                    handleTranslateLang((_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.id, value, from);
                }, translateInfo: translateInfoMidMap[(_0 = content === null || content === void 0 ? void 0 : content.entry) === null || _0 === void 0 ? void 0 : _0.id], unlockMail: unlockMail, style: { marginTop: '8px' }, showMailHead: showMailHead, onShowMailHeadChange: setShowMailHead, forceUpdate: forceUpdate })),
            React.createElement(Content, { merge: true, showWrap: true, ref: re => {
                    if (re) {
                        contentRef.current[ckey] = re;
                        re.key = content.entry.id;
                    }
                }, content: content, listData: readStatus, forceUpdate: forceUpdate, onIframeSizeChange: handleIframeSizeChange, onIframeScroll: handleIframeScroll, freezeMouse: freezeMouse || _freezeMouse }),
            React.createElement("div", null,
                React.createElement(HorizontalScrollBar, { viewWidth: iframeWidth, scrollWidth: iframeContentWidth, scrollLeft: scrollLeft, onScroll: handleVScrollOnScroll, show: true, onDragStart: () => {
                        setFreezeMouse(true);
                    }, onDragEnd: () => {
                        setFreezeMouse(false);
                    } })),
            readOnly ? React.createElement(React.Fragment, null) : React.createElement(ReplyWrap, { content: content, mid: (_1 = content === null || content === void 0 ? void 0 : content.entry) === null || _1 === void 0 ? void 0 : _1.id, nofix: replayFixed, handleEmoticon: handleEmoticon, emoticonInfo: emotionInfo }))));
};
export default MergePanelMail;
